import {
    EventPanelFormType as CadApiEventPanelFormType,
    ConsolidatedLocationView,
    EventDrugsDto,
    EventFirearmDto,
    EventOtherItemDto,
} from '@mark43/cad-api';

export enum EntityTypes {
    REPORTING_PARTIES = 'reportingParties',
    VEHICLES = 'vehicles',
    TOW_VEHICLES = 'towVehicles',
    INVOLVED_PERSONS = 'involvedPersons',
    FIREARMS = 'firearms',
    DRUGS = 'drugs',
    OTHER_ITEMS = 'otherItems',
}

export enum MergedEntityTypes {
    REPORTING_PARTIES = 'mergedReportingParties',
    VEHICLES = 'mergedVehicles',
    TOW_VEHICLES = 'mergedTowVehicles',
    INVOLVED_PERSONS = 'mergedInvolvedPersons',
    FIREARMS = 'mergedFirearms',
    DRUGS = 'mergedDrugs',
    OTHER_ITEMS = 'mergedOtherItems',
}

export type CorrectedLocation = ConsolidatedLocationView | null;

type CorrectedReportingParty = CadApiEventPanelFormType['reportingParties'][0] & {
    location: CorrectedLocation;
};

type CorrectedInvolvedPerson = CadApiEventPanelFormType['involvedPersons'][0] & {
    location: CorrectedLocation;
};

type CorrectedVehicle = CadApiEventPanelFormType['vehicles'][0] & {
    towedFromLocation: CorrectedLocation;
    towedToLocation: CorrectedLocation;
};

type CorrectedTowVehicle = CadApiEventPanelFormType['towVehicles'][0] & {
    towedFromLocation: CorrectedLocation;
    towedToLocation: CorrectedLocation;
};

export type CorrectedFirearm = CadApiEventPanelFormType['firearms'][0];
export type CorrectedDrugs = CadApiEventPanelFormType['drugs'][0];
export type CorrectedOtherItem = CadApiEventPanelFormType['otherItems'][0];

export type Person = CorrectedReportingParty | CorrectedInvolvedPerson;
export type Vehicle = CorrectedVehicle | CorrectedTowVehicle;
export type Property =
    | CorrectedFirearm
    | CorrectedDrugs
    | CorrectedOtherItem
    | EventFirearmDto
    | EventDrugsDto
    | EventOtherItemDto;
export type Entity = Person | Vehicle | Property;

export interface FrEventFormType extends CadApiEventPanelFormType {
    location: CorrectedLocation;
    reportingParties: CorrectedReportingParty[];
    vehicles: CorrectedVehicle[];
    towVehicles: CorrectedTowVehicle[];
    involvedPersons: CorrectedInvolvedPerson[];
    mergedReportingParties: CorrectedReportingParty[];
    mergedVehicles: CorrectedVehicle[];
    mergedTowVehicles: CorrectedTowVehicle[];
    mergedInvolvedPersons: CorrectedInvolvedPerson[];
    firearms: CorrectedFirearm[];
    mergedFirearms: CorrectedFirearm[];
    drugs: CorrectedDrugs[];
    mergedDrugs: CorrectedDrugs[];
    otherItems: CorrectedOtherItem[];
    mergedOtherItems: CorrectedOtherItem[];
}
